import React from 'react';
import { Drawer as MuiDrawer } from '@mui/material';
import { DrawerProps } from './model';
export type { DrawerProps } from './model';

export const Drawer: React.FC<DrawerProps> = (props) => {
  return <MuiDrawer {...props} />;
};
